var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostFumigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7673 3.20573C12.7673 2.98383 12.5776 2.80396 12.3436 2.80396C12.1096 2.80396 11.9199 2.98383 11.9199 3.20573V12.0982C11.9199 12.3201 12.1096 12.5 12.3436 12.5C12.5776 12.5 12.7673 12.3201 12.7673 12.0982V3.20573ZM7.23254 11.862C7.23254 12.0839 7.42223 12.2639 7.65622 12.2639C7.89021 12.2639 8.07989 12.0839 8.07989 11.862V3.20573C8.07989 2.98383 7.89021 2.80396 7.65622 2.80396C7.42223 2.80396 7.23254 2.98383 7.23254 3.20573V11.862Z",
    fill: "#1E3A8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2318 1H6.76769C6.45501 1 6.20154 1.24038 6.20154 1.53689V2.66882C6.20154 2.96533 6.45501 3.20571 6.76769 3.20571H13.2318C13.5445 3.20571 13.798 2.96533 13.798 2.66882V1.53689C13.798 1.24038 13.5445 1 13.2318 1Z",
    fill: "#1E3A8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52429 7.65186H10.8253V8.04316H7.52429V7.65186Z",
    fill: "#1E3A8A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.1738H11.301V10.5651H8V10.1738Z",
    fill: "#1E3A8A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52429 6.47803H9.58744V6.86933H7.52429V6.47803Z",
    fill: "#1E3A8A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9H10.0631V9.3913H8V9Z",
    fill: "#1E3A8A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52429 5.30444H10.8253V5.69575H7.52429V5.30444Z",
    fill: "#1E3A8A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.87366 5.30427L4.21412 2.97866C2.52161 0.559565 0.0451139 2.90807 2.59601 4.51311L5.0484 6.08687L5.87366 5.30427Z",
    fill: "#1E3A8A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9514 13.9131L17.4038 15.4868C19.9547 17.0919 17.4782 19.4404 15.7857 17.0213L14.1262 14.6957L14.9514 13.9131Z",
    fill: "#1E3A8A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7673 16.3759V5C12.1523 5 11.5373 4.76382 10.9224 4.76382C10.3074 4.76382 9.6924 5 9.07747 5C8.4625 5 7.84752 4.76382 7.23254 4.76382V4.99988V6.54496V16.3759C7.23254 17.8193 8.47787 19.0003 9.99991 19.0003C11.522 19.0003 12.7673 17.8193 12.7673 16.3759Z",
    fill: "#1E3A8A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2014 14.7566L13.1063 13.7182V12.1731L15.016 13.9841L14.2014 14.7566Z",
    fill: "#1E3A8A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8938 7.82649L4.98411 6.01546L5.79875 5.24292L6.8938 6.28137V7.82649Z",
    fill: "#1E3A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostFumigation);
export default __webpack_public_path__ + "static/media/PostFumigation.372c17c08df9d9ec367638c91f2eb48d.svg";
export { ForwardRef as ReactComponent };